/**
 * In Audit API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 */
export const TemplateAvailabilityStatus = {
    Active: 'active',
    InactiveManual: 'inactiveManual',
    InactivePlan: 'inactivePlan'
} as const;
export type TemplateAvailabilityStatus = typeof TemplateAvailabilityStatus[keyof typeof TemplateAvailabilityStatus];

